
<template>
    <iframe name="report" height="100%" width="100%" style="border:0;" src="//wbcp.office4u.xyz/download"></iframe>
</template>

<script>
export default {
    name: 'Download-Link',
    data() {
        return {

        }
    }
}
</script>


